class VariantMonitor {
  constructor() {
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.captureInitialVariant());
    } else {
      this.captureInitialVariant();
      setTimeout(() => this.captureInitialVariant(), 100);
    }
  }

  captureInitialVariant() {
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const variant = productInfo.getSelectedVariant(productInfo);
      window.dispatchEvent(new CustomEvent('variant:changed', {
        detail: {
          variant,
          selectedOptions: [],
          isInitial: true,
          timestamp: new Date().toISOString()
        }
      }));
    }
  }

  handleVariantChange(event) {
    const { data: { variant } } = event;
    window.dispatchEvent(new CustomEvent('variant:changed', {
      detail: {
        variant,
        selectedOptions: [],
        isInitial: false,
        timestamp: new Date().toISOString()
      }
    }));
  }

  disconnect() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }
}

const variantMonitor = new VariantMonitor();

window.variantMonitor = variantMonitor;